export const headerType = {
  myidea: 1,
  noLoginMyidea: 2,
  interserve: 3,
  noMenu: 4,
  uraidea: 9
}
